import React, { Component, useState } from "react";
import { connect } from "react-redux";
import { Input } from "reactstrap";
import { withRouter } from "react-router-dom";
import { Search, Bell, AlignJustify } from "react-feather";
import Logo from "assets/img/logo.png";
import LoginPopup from "./components/LoginPopup";
import NotificationSidebar from "./components/NotificationSidebar";
import UserDropdown from "./components/UserDropdown";
import MenuDropdown from "./MenuDropdown";
import MobileHamburgerSidebar from "components/Navbars/components/MobileHamburgerSidebar";
import threeD from "components/Navbars/img/threeD.png";
import { Link } from "react-router-dom";
import { getSUGGESTIONAction } from "store/Search";
import Autosuggest from "react-autosuggest";
import search from "assets/styles/search.css";
import job from "assets/img/job.png";
import portfolio from "assets/img/portfolio.png";
import course from "assets/img/course.png";
// const Navigation = (props) => {
const renderSuggestion = (suggestion) => {
  // console.log(suggestion);
  return (
    <div className="flex items-center">
      {suggestion.type == "jobs" ? (
        <img src={job} alt="jobs" className="w-50px  h-50px"></img>
      ) : suggestion.type == "course" ? (
        <img src={course} alt="course" className="w-50px  h-50px"></img>
      ) : (
        <img src={portfolio} alt="portfolio" className="w-50px  h-50px"></img>
      )}

      <p className="font-semibold fsize16 ml-3">
        {suggestion.title + "   -  " + suggestion.type}
      </p>
    </div>
  );
};
{
  /* <div>{suggestion.title}</div>; */
}
const getSuggestionValue = (suggestion) => suggestion.title;
class Navigation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: false,
      shownotification: false,
      ShowMobileHamburger: false,
      Suggestions: [],
      value: "",
    };
  }
  componentDidMount() {
    // this.getSuggestions("client");
  }
  onSuggestionsClearRequested() {
    this.setState({
      Suggestions: [],
    });
  }
  async onSuggestionsFetchRequested({ value }) {
    this.setState({
      Suggestions: await this.getSuggestions(value),
    });
    // this.setState({
    //   Suggestions: this.getSuggestions(value),
    // });
  }
  async getSuggestions(value) {
    try {
      let Suggestions = [];
      const inputValue = value.trim().toLowerCase();
      const inputLength = inputValue.length;
      let response = await this.props.getSUGGESTION({ keyword: value });
      if (response) {
        Suggestions = response.Data;
      }
      // console.log(Suggestions);
      return inputLength === 0 ? [] : Suggestions;
      // return Suggestions;
    } catch (e) {
      console.log(e);
    }
  }
  onChange = (event, { newValue }) => {
    // console.log(newValue)
    this.setState({
      value: newValue,
    });
    // console.log(this.state.value)
  };
  onSuggestionSelected(
    event,
    { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }
  ) {
    debugger;
    if (suggestion.type == "jobs") {
      this.props.history.push(
        process.env.PUBLIC_URL + "/Career/job-details/" + suggestion.id
      );
    } else if (suggestion.type == "course") {
      this.props.history.push(
        process.env.PUBLIC_URL + "/Career/ilearn-details/" + suggestion.id
      );
    } else if (suggestion.type == "portfolio") {
      this.props.history.push(
        process.env.PUBLIC_URL + "/Career/know-us-more/" + suggestion.id
      );
    }
  }
  render() {
    const { value, Suggestions } = this.state;
    const inputProps = {
      placeholder: "Search for jobs events or programs",
      className:
        "cust-search500 cust-shadow-md fsize16 py-4 px-6 rounded-full ",
      value,
      name: "search",
      onChange: this.onChange,
    };
    return (
      <div class="header bg-white sticky-header-s sm-bshadow-20">
        <div>
          <NotificationSidebar shownotification={this.state.shownotification} />
          <MobileHamburgerSidebar
            ShowMobileHamburger={this.state.ShowMobileHamburger}
            className="lg:hidden md:hidden"
          />
          <nav className="flex items-center justify-center flex-wrap bg-white ">
            <div className="container flex justify-between items-center">
              <div className="flex items-center flex-shrink-0 py-4  mr-6 lg:px-0 md:px-0 px-4">
                <AlignJustify
                  className="mr-4 hidden  "
                  onClick={() => this.setState({ ShowMobileHamburger: true })}
                />
                <Link
                // to={{
                //   pathname: process.env.PUBLIC_URL + "/Career/home/",
                //   // state:this.props.knowusmore.Data[0].p_id
                // }}
                >
                  <img src={Logo} alt="logo" className="logo_w" />
                </Link>
              </div>
              <Bell
                className="text053C6D cursor-pointer mx-4 hidden"
                onClick={() => {
                  this.setState({ shownotification: true });
                }}
              />
              <div className="block hidden">
                <button
                  className="flex items-center px-3 py-2 border rounded text-teal-200 border-teal-400 hover:text-white hover:border-white"
                  onClick={() =>
                    this.setState({ isExpanded: !this.state.isExpanded })
                  }
                >
                  <svg
                    className="fill-current h-3 w-3"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <title>Menu</title>
                    <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
                  </svg>
                </button>
              </div>
              <div
                className={`${
                  this.state.isExpanded ? `block` : `hidden`
                } w-full block flex-grow lg:flex lg:items-center lg:w-auto flex justify-end`}
              >
                <div className="text-sm lg:flex-grow items-center flex">
                  <div className="flex  justify-end  items-center w-full">
                    {/* <div className="relative mr-6">
                    
                      <Autosuggest
                        suggestions={Suggestions}
                        onSuggestionsFetchRequested={
                          this.onSuggestionsFetchRequested.bind(this)
                        }
                        onSuggestionsClearRequested={
                          this.onSuggestionsClearRequested.bind(this)
                        }
                        getSuggestionValue={getSuggestionValue}
                        renderSuggestion={renderSuggestion}
                        inputProps={inputProps}
                        onSuggestionSelected={this.onSuggestionSelected.bind(this)}
                      />

                      <Search
                        width="23"
                        height="23"
                        className="absolute search-icon-tr"
                      />
                    </div>{" "} */}
                    {/* <div className="flex items-center ">
                      <img
                        src={threeD}
                        alt="3d"
                        className="w-40px h-40px cursor-pointer mr-2"
                        onClick={() =>
                          this.props.history.push(
                            `${process.env.PUBLIC_URL}/Career/3d`
                          )
                        }
                      /> */}
                    {/* <p
                        className="font-medium fsize18 p-4 mr-2 cursor-pointer"
                        to={{
                          pathname:
                            process.env.PUBLIC_URL + "/Career/contact-us",
                          // state:this.props.knowusmore.Data[0].p_id
                        }}
                      >
                        Contact us{" "}
                      </p> */}

                    {/* <MenuDropdown /> */}

                    {/* <LoginPopup /> */}
                    {/* </div> */}
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {};
};
const mapDispatchToProps = (dispatch) => {
  return {
    getSUGGESTION: async (payload) =>
      await dispatch(getSUGGESTIONAction(payload)),
  };
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Navigation)
);
